module.exports = __webpack_public_path__ + "img/overview-giftcards.7905a0aa.svg";